import axios from 'axios';

import { isArrayString } from '../../../utils/typeGuard/typeGuard.util';

const s3HeadersArrayToObj = (headersArray: string[]): Record<string, string> =>
  Object.fromEntries<string>(
    headersArray.map((item) => {
      const [key = '', value = ''] = item.split(': ');

      return [key, value];
    }),
  );

/**
 * Upload files to AWS S3 by given URL
 */
export const putFileByUrl = async (
  url: string,
  headers: Record<string, string> | string[],
  file: File | ArrayBuffer,
): Promise<void> => {
  const headersMapped = isArrayString(headers) ? s3HeadersArrayToObj(headers) : headers;
  await axios.put(url, file, { headers: headersMapped });
};
